import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Toolbar} from 'primereact/toolbar';
import { useHistory, Link } from "react-router-dom";
import moment from 'moment';
import loader from '../loader';
import typeOptions from './types.json';
import { ProgressSpinner } from 'primereact/progressspinner';
import Session from '../auth/Session';
import timeSetup from '../timeSetup';

const getItems = (res, setItems) => {
    let titems = res.items;
    titems = titems.map(i => ({
        ...i,
        start: timeSetup.from(i.start).format('YYYY-MM-DD HH:mm:ss'),
        end: timeSetup.from(i.end).format('YYYY-MM-DD HH:mm:ss')    
    }))
    setItems(titems);
}

function ClientOutList(props) {
  const { client_id } = props;

  let [ items, setItems ] = useState([]);
  
  let [ success, setSuccess ] = useState('');
  let [ loading, setLoading ] = useState(false);

  let history = useHistory();

  useEffect(() => {
    if (client_id) {
        loader.get('/clientout/client/' + client_id, res => {
            if (!res.success) return;
            getItems(res, setItems);
        }, setLoading);
    } else {
        loader.get('/clientout/list', res => {
            if (!res.success) return;
            getItems(res, setItems);
        }, setLoading);    
    }
  }, []);

  let deleteItem = (id) => {
    const url = '/clientout/delete/' + id;
    setLoading(true);
    setSuccess(false);
    loader.get(url, {
        headers: {
            'content-type': 'application/json'
        }
    })
    .then(res => res.json())
    .then(res => {
        setLoading(false);
        setSuccess(true);
        items = items.filter(i => i.id !== id);
        setItems(items);
    })
    .catch(err => {
        setLoading(false);
        console.log(err);
    });
  };

  let recordOptions = (item, column) => {
    const logged = Session.getCookie();
    return <div>
        <Button
            onClick={e => history.push({ pathname: '/backoffice/clientouts/form/' + item.id })} 
            type="button" 
            icon="pi pi-pencil" 
            className="p-button-info"
        />
        <Button
            onClick={e => deleteItem(item.id)} 
            type="button" 
            icon="pi pi-times" 
            className="p-button-danger"
            disabled={![logged.role1].includes('ADMINISTRATOR')}
        />
    </div>;
  }

  const getOptionLabel = (options, value) => {
    const item = options.find(opt => opt.value === value);
    return item ? item.label : value;
  }

  if (loading) return <ProgressSpinner />;
  let createUrl = "/backoffice/clientouts/form/0" + (client_id ? "/" + client_id : "");
  return (
    <React.Fragment>

        <Toolbar>
            <div className="p-toolbar-group-left">
                <Link to={createUrl}>
                    <Button label="Inserir Nova" />
                </Link>
            </div>
            <div className="p-toolbar-group-right">
                
            </div>
        </Toolbar>

        { success && (
            <div className="p-grid">
                <div className="p-col-12">

                    <Message 
                        severity="success" 
                        text="A ausência foi alterada com sucesso!">
                    </Message>
                    
                </div>
            </div>
        ) }
        
        <div className="p-grid">
            <div className="p-col-12">

            <DataTable value={items} responsive={true}>
                { !client_id && (
                    <Column 
                        header="Cliente"
                        field="firstname"  
                        sortable={true}
                        filter={true}
                        filterMatchMode="contains"
                    />
                ) }
                
                <Column 
                    header="Tipo" 
                    field="type"
                    sortable={true}
                    filter={true}
                    filterMatchMode="contains"
                    body={i => getOptionLabel(typeOptions, i.type)} 
                />
                
                <Column 
                    header="Inicio" 
                    filter={true}
                    filterMatchMode="contains"
                    body={item => item.start ? moment(item.start).format('YYYY-MM-DD HH:mm:ss') : ''}
                />
                <Column 
                    header="Fim" 
                    filter={true}
                    filterMatchMode="contains"
                    body={item => item.end ? moment(item.end).format('YYYY-MM-DD HH:mm:ss') : ''}
                />

                <Column body={recordOptions} header="Opções" />
            </DataTable>
                
            </div>
        </div>
            
    </React.Fragment>
  );

}

export default ClientOutList;
